import Main from '@/views/administracion/programacion/Main.vue';
import Default from '@/views/administracion/programacion/Default.vue';

const auth = ['Programación:ver'];
const scopes = ['Programación:crear', 'Programación:editar', 'Programación:eliminar'];

const programacion = [
  {
    path: 'programacion',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'programacion',
        path: '/',
        meta: {
          title: 'Programacion',
          auth,
          scopes,
        },
        component: Default,

        children: [],
      },
    ],
  },
];

export default programacion;
